export interface HavuRuntimeConfig {
  apiBasePath?: string;
  stripePublishableKey?: string;
}

declare global {
  interface Window {
    HAVU_CONFIG?: HavuRuntimeConfig;
    /** Legacy API-only override retained for existing deployments. */
    SC_AUDIT_STUDIO_API_BASE_PATH?: string;
  }
}

export const getRuntimeConfigValue = (key: keyof HavuRuntimeConfig): string => {
  const value = window.HAVU_CONFIG?.[key];

  return typeof value === 'string' ? value.trim() : '';
};
